export const DEFAULT_VOICE = "en-US-AndrewMultilingualNeural";

export const AZURE_VOICES = [
  { value: "en-US-AndrewMultilingualNeural", label: "Andrew", detail: "English (US) · Male" },
  { value: "en-US-AvaMultilingualNeural", label: "Ava", detail: "English (US) · Female" },
  { value: "en-US-EmmaMultilingualNeural", label: "Emma", detail: "English (US) · Female" },
  { value: "en-US-DustinMultilingualNeural", label: "Dustin", detail: "English (US) · Male" },
  { value: "en-US-CoraMultilingualNeural", label: "Cora", detail: "English (US) · Female" },
  { value: "en-US-JennyMultilingualNeural", label: "Jenny", detail: "English (US) · Female" },
  { value: "en-US-AdamMultilingualNeural", label: "Adam", detail: "English (US) · Male" },
  { value: "en-GB-AdaMultilingualNeural", label: "Ada", detail: "English (UK) · Female" },
  { value: "en-GB-OllieMultilingualNeural", label: "Ollie", detail: "English (UK) · Male" },
] as const;

export const OPENAI_VOICES = [
  { value: "alloy", label: "Alloy", detail: "Neutral" },
  { value: "ash", label: "Ash", detail: "Male" },
  { value: "ballad", label: "Ballad", detail: "Female" },
  { value: "coral", label: "Coral", detail: "Female" },
  { value: "echo", label: "Echo", detail: "Male" },
  { value: "fable", label: "Fable", detail: "British Male" },
  { value: "onyx", label: "Onyx", detail: "Deep Male" },
  { value: "nova", label: "Nova", detail: "Female" },
  { value: "sage", label: "Sage", detail: "Neutral" },
  { value: "shimmer", label: "Shimmer", detail: "Female" },
  { value: "verse", label: "Verse", detail: "Male" },
] as const;

export const GRAMMAR_OPENAI_VOICES = [
  { value: "alloy", label: "Alloy", detail: "Neutral" },
  { value: "verse", label: "Verse", detail: "Male" },
  { value: "nova", label: "Nova", detail: "Female" },
  { value: "coral", label: "Coral", detail: "Female" },
] as const;

// Curated Azure Speech neural voices for the grammar conversation (East Asia, low latency).
// Kept separate from the shared AZURE_VOICES editor list so tuning this set never affects editors.
export const GRAMMAR_AZURE_VOICES = [
  {
    value: "en-US-AvaMultilingualNeural",
    label: "Ava",
    detail: "Female · most natural, conversational",
  },
  {
    value: "en-US-EmmaMultilingualNeural",
    label: "Emma",
    detail: "Female · warm, friendly (great for children)",
  },
  { value: "en-US-JennyNeural", label: "Jenny", detail: "Female · clear, polished, reliable" },
  { value: "en-US-AriaNeural", label: "Aria", detail: "Female · expressive, energetic" },
  { value: "en-US-SaraNeural", label: "Sara", detail: "Female · friendly, youthful" },
  {
    value: "en-US-AndrewMultilingualNeural",
    label: "Andrew",
    detail: "Male · most natural, calm, warm",
  },
  {
    value: "en-US-BrianMultilingualNeural",
    label: "Brian",
    detail: "Male · clear, mature, steady",
  },
  { value: "en-US-GuyNeural", label: "Guy", detail: "Male · strong, polished" },
  {
    value: "en-US-ChristopherNeural",
    label: "Christopher",
    detail: "Male · natural, professional",
  },
  { value: "en-US-EricNeural", label: "Eric", detail: "Male · clear, neutral" },
] as const;

// Selectable speaking rates for the grammar conversation (SSML <prosody rate>). Bounded so an admin
// can't pick a rate that time-stretches the voice into sounding artificial.
export const GRAMMAR_TTS_SPEEDS = [
  { value: "0.75", label: "0.75x", detail: "Slowest \u00b7 for beginners" },
  { value: "0.80", label: "0.80x", detail: "Very slow" },
  { value: "0.85", label: "0.85x", detail: "Slow (default)" },
  { value: "0.90", label: "0.90x", detail: "Slightly slow" },
  { value: "0.95", label: "0.95x", detail: "Near natural" },
  { value: "1.00", label: "1.00x", detail: "Natural pace" },
] as const;

export const DEFAULT_GRAMMAR_TTS_SPEED = 0.85;

export type AzureVoiceValue = (typeof AZURE_VOICES)[number]["value"];
export type OpenAIVoiceValue = (typeof OPENAI_VOICES)[number]["value"];
export type GrammarOpenAIVoiceValue = (typeof GRAMMAR_OPENAI_VOICES)[number]["value"];
export type GrammarAzureVoiceValue = (typeof GRAMMAR_AZURE_VOICES)[number]["value"];
